export const PRELOAD_TESTANIA = '/';
